export default {

    name: 'CustomTheme',
    prefix: 'customTheme',
    //TM-Branding-START
    rootStyle: {
        //Typography branding
        //'--GW-FONT-SANS-SERIF': 'Helvetica,Arial,sans-serif',
        '--GW-FONT-SANS-SERIF': '\"Open Sans\",sans-serif',
        
        //color theme for menu box
        '--GW-COLOR-BRAND-3': '#7aC043', // Green
        '--GW-COLOR-BRAND-3-CONTRAST': 'var(--GW-COLOR-LIGHT-CONTRAST)', //Black
        '--GW-COLOR-BRAND-3-HOVER': '#aba9ab',
        '--GW-COLOR-BRAND-3-ACTIVE': '#002D72',
        '--GW-COLOR-HIGHLIGHT-2': '#FFFFFF',
        //color theme for button
        '--GW-COLOR-BRAND-1': '#002D72', // Blue
        '--GW-COLOR-BRAND-1-CONTRAST': 'var(--GW-COLOR-DARK-CONTRAST)',
        '--GW-COLOR-BRAND-1-HOVER': '#007852',
        '--GW-COLOR-BRAND-1-ACTIVE': '#70a087',
        '--GW-COLOR-BRAND-1-GRADIENT': '#007852',
        '--GW-COLOR-BRAND-1-GRADIENT-HOVER': '#007852',
        '--GW-COLOR-BRAND-1-GRADIENT-ACTIVE': '#70a087',
        '--GW-COLOR-BACKGROUND-2': '#F5F5F5',
        '--GW-COLOR-BRAND-EY-ACTIVE': 'var(--GW-COLOR-BRAND-1)',
        '--icon-button-color': 'var(--GW-COLOR-BRAND-1)',
        //'--GW-COLOR-HIGHLIGHT-1-HOVER': '#7aC043',
        '--GW-COLOR-BRAND-4': '#76bfea',

        '--GW-COLOR-BRAND-2':'#eb8000',
        '--GW-COLOR-BRAND-2-HOVER': '#7ac043',
        '--GW-COLOR-BRAND-2-GRADIENT': '#7ac043',
        '--GW-COLOR-TEXT-1': '#000000', //Black


         '--GW-COLOR-FOCUS-1': 'none',//'var(--GW-COLOR-BRAND-1-ACTIVE)',  //use for accordian focus box
        // '--GW-COLOR-FOCUS-1-CONTRAST': 'var(--GW-COLOR-LIGHT-CONTRAST)',
        // '--GW-COLOR-FOCUS-1-HOVER': 'var(--GW-COLOR-BRAND-1-ACTIVE)',
        // '--GW-COLOR-FOCUS-1-ACTIVE': 'var(--GW-COLOR-BRAND-1-ACTIVE)',
        //color theme for top frame
      //  '--GW-COLOR-BRAND-2': '#F5F5F5'
        '--GW-COLOR-BRAND-2-CONTRAST': 'var(--GW-COLOR-DARK-CONTRAST)',
        //'--GW-COLOR-BRAND-2-HOVER': '#002D72',
        '--GW-COLOR-BRAND-2-ACTIVE': '#fc8f0d',

        '--GW-BOX-SHADOW-FOCUS' : 'none',//'#70a087', //use for accordian focus box
        '--NEXUS-COLOR-BRAND-1': '#F5F5F5', //for top frame background and login page
        '--NEXUS-COLOR-BRAND-2': '#7aC043', // Green
        '--NEXUS-COLOR-BRAND-3': '#1e9acf', //Blue
        '--NEXUS-SPACING-HEADER': '65px',
        '--GW-COLOR-HIGHLIGHT-2': '#FFFFFF',
        //'--NEXUS-BODY-FONT-FAMILY': 'Open Sans",sans-serif'
        '--header-button-focus-border-size': 'var(--GW-BORDER-WIDTH-THICK)',
        '--burger-bars-background-color': 'var(--GW-COLOR-BRAND-1)',
        '--NEXUS-COLOR-DISABLE-1': '#6B6B6B'

    },
    componentStyles: {
        ApplicationHeader: {
            applicationHeaderWrapper: {
               // '--application-header-header-background-color':' var(--NEXUS-COLOR-BRAND-1)',

                'position': 'sticky',

                'top': 'calc(3.5 * var(--GW-SPACING-XXL))',

                'width': '100%',

                'z-index': '150',

                'height': 'auto',

                'box-shadow': 'var(--GW-BOX-SHADOW-OUTER-2)'
            }
        },
         Button: {
            button: {
                
            '--button-hover-bg-image': 'linear-gradient(240deg, var(--GW-COLOR-BRAND-2-HOVER) 0%, var(--GW-COLOR-BRAND-2-HOVER) 100%)',
            '--button-hover-color': 'var(--GW-COLOR-LIGHT-CONTRAST)', //'#007852',
            //'--button-border': 'solid',
            '--button-box-shadow': 'none',
              }
         },
        InfoLabel : {
            neutral : {
               '--info-label-bg-color' : '#002D72',
                '--info-label-color' : 'var(--GW-COLOR-ALERT-INFO-CONTRAST)'
            }
        },
        Table: {
             table: {
                // 'padding': 'var(--table-padding-y) var(--table-padding-y) var(--table-padding-y) var(--table-padding-y)'
                padding: '0px'
             },
             tableCell:{
                'vertical-align': 'middle'
             }
        },
    }

    
    //AM-Branding-END
};